import React from 'react'
import { Link } from 'react-router-dom';
import service_baner2 from "../Assets/images/service_baner2.png";
import { title } from '../config/Config';
import { Biotech, CodeOff, Email, Margin, ScreenSearchDesktop, ShowChart, Star, VerticalSplit, WebAsset } from '@mui/icons-material';
import avatar from "../Assets/images/avatar.webp";
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import { Mousewheel, Autoplay, Pagination, Navigation } from 'swiper/modules';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import dashboard_image from "../Assets/images/dashboard_image.webp"

const Services = () => {
    const [selectedTab, setSelectedTab] = React.useState(0);

    const handleTabSelect = (index: number) => {
        setSelectedTab(index);
    };

    return (
        <>
            <div className="service_page">
                <div className="service_baner">
                    <div className="container-layout">
                        <div className="row service_row">
                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <h1>Services</h1>
                                <p>
                                    Welcome to {title}, where we offer an array of services designed to meet your needs and exceed your expectations. Our commitment is to provide top-notch solutions tailored to suit you perfectly. Explore our diverse range of services:
                                </p>
                                <div className='mt-4'><Link to='/contact' className='service_btn'>Contact</Link></div>
                            </div>

                            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                                <div className="right_img">
                                    <img src={service_baner2} alt='service_baner' />
                                </div>

                            </div>
                        </div>
                    </div>

                </div>

                <div className="service_sec">
                    <div className="container-layout">
                        <p className='text-center primary_text'>Best Service</p>
                        <h2 className='text-center'>Our <span>Best Service</span></h2>
                        <p className='text-center'>
                            We have a wide range of services to offer in our bag. Our services are customer-centric and result- oriented. With the varied range of services and purposeful
                            solutions, we endeavor to nurture and evolve your ideas into custom, premium, well-designed and developed distinctive websites that will go beyond your
                            imagination and turn your dreams into reality. Check out our range of services, which we assure to  offer with quality and successful results:
                        </p>

                        

                        <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                <div className="card">
                                    <div className="img_box">
                                        <Margin />
                                    </div>

                                    <div className="card_title">WEBSITE DESIGNING</div>
                                    <div className="card_text">
                                        Web Designing in impressive way is not just a profession but passion for our Company...
                                    </div>


                                    <Link to="/web-design" className='service_link'>Learn More</Link>

                                </div>
                            </div>

                            <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                <div className="card">
                                    <div className="img_box">
                                        <CodeOff />
                                    </div>

                                    <div className="card_title">WEBSITE DEVELOPMENT</div>
                                    <div className="card_text">
                                        Gs Infotech Web Solutions designs and develops Web Applications that are business-critical...
                                    </div>


                                    <Link to="/webdeveloper" className='service_link'>Learn More</Link>

                                </div>
                            </div>


                            <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                <div className="card">
                                    <div className="img_box">
                                        <VerticalSplit />
                                    </div>

                                    <div className="card_title">WORDPRESS WEBSITE DESIGN</div>
                                    <div className="card_text">
                                        Gs Infotech Web Solutions offers a
                                        rich repertoire of software
                                        services to its clients
                                        seeking...
                                    </div>


                                    <Link to="/wordpress" className='service_link'>Learn More</Link>

                                </div>
                            </div>


                            <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                <div className="card">
                                    <div className="img_box">
                                        <ScreenSearchDesktop />
                                    </div>

                                    <div className="card_title">SEARCH ENGINE OPTIMIZATION</div>
                                    <div className="card_text">
                                        Gs Infotech Web Solutions offering professional SEO Services In Chandigarh, Mohali Himachal...
                                    </div>


                                    <Link to="/search-engine" className='service_link'>Learn More</Link>

                                </div>
                            </div>


                            <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                <div className="card">
                                    <div className="img_box">
                                        <WebAsset />
                                    </div>

                                    <div className="card_title">WEB HOSTING</div>
                                    <div className="card_text">
                                        GNI Soft olutions a web hosting company based out of Chandigarh, India. We are a....
                                    </div>


                                    <Link to="/webhosting" className='service_link'>Learn More</Link>

                                </div>
                            </div>


                            <div className="col-sm-6 col-md-6 col-lg-4 col-xl-4">
                                <div className="card">
                                    <div className="img_box">
                                        <Email />
                                    </div>

                                    <div className="card_title">BULK SMS & EMAIL HOSTING</div>
                                    <div className="card_text">
                                        Bulk SMS Service is cheaper and more reliable service that allows you to communicate...
                                    </div>


                                    <Link to="/email-hosting" className='service_link'>Learn More</Link>

                                </div>
                            </div>

                        </div>
                    </div>
                </div>

                <div className="value_cards">
                    <div className="container-layout">
                        <div className="row">
                            <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
                                <div className="value_card" style={{ backgroundColor: '#e1fcdc' }}>
                                    <div className="heading">50K</div>
                                    <div className="small_text">Total Users</div>
                                </div>
                            </div>

                            <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
                                <div className="value_card" style={{ backgroundColor: '#e3e8ff' }}>
                                    <div className="heading">32K</div>
                                    <div className="small_text">Downloads</div>
                                </div>
                            </div>


                            <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
                                <div className="value_card" style={{ backgroundColor: '#ffedef' }}>
                                    <div className="heading">90K</div>
                                    <div className="small_text">Social Likes</div>
                                </div>
                            </div>

                            <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3">
                                <div className="value_card" style={{ backgroundColor: '#fff9e6' }}>
                                    <div className="heading">25K</div>
                                    <div className="small_text">Subscribers</div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

                <div className="technology_sec">
                    <div className="container-layout">
                        <p className='text-center primary_text'>HELPING ENTREPRENEURS MAKE MORE MONEY</p>
                        <h2 className='text-center'><span>Focus on cutting-edge</span> technologies and cost-quality efficiency</h2>

                        <div className="slider_new">
                            <Tabs
                                selectedIndex={selectedTab}
                                onSelect={(index) => handleTabSelect(index)}
                            >
                                <TabList>
                                    <Tab>
                                        <div className="tab_flex">
                                            <div className="icon"><ShowChart style={{ backgroundColor: '#e1fcdc' }}/></div>

                                            <div className="div">
                                                <h5>Strategy & Business</h5>
                                                <h6>We design business models and growth strategies to be effective and competitive.</h6>
                                            </div>
                                        </div>
                                    </Tab>

                                    <Tab>
                                        <div className="tab_flex">
                                            <div className="icon"><CodeOff style={{ backgroundColor: '#e3e8ff' }}/></div>

                                            <div className="div">
                                                <h5>Futures Research</h5>
                                                <h6>We design business models and growth strategies to be effective and competitive.</h6>
                                            </div>
                                        </div>
                                    </Tab>

                                    <Tab>
                                        <div className="tab_flex">
                                            <div className="icon"><Biotech style={{ backgroundColor: '#ffedef' }}/></div>

                                            <div className="div">
                                                <h5>Product Development</h5>
                                                <h6>We design business models and growth strategies to be effective and competitive.</h6>
                                            </div>
                                        </div>
                                    </Tab>
                                </TabList>

                                <TabPanel>
                                   <div className="tab_panel_inner">
                                        <img src={dashboard_image} alt='dashboard_image'/>
                                   </div>
                                </TabPanel>

                                <TabPanel>
                                   <div className="tab_panel_inner">
                                        <img src={dashboard_image} alt='dashboard_image'/>
                                   </div>
                                </TabPanel>

                                <TabPanel>
                                   <div className="tab_panel_inner">
                                        <img src={dashboard_image} alt='dashboard_image'/>
                                   </div>
                                </TabPanel>
                            </Tabs>
                        </div>
                    </div>
                </div>

                <div className="customer_slider">
                    <div className="container-layout">
                        <h2 className='text-center'>What our <span>customers are saying </span></h2>

                        <div className='swiper_customer'>
                            <Swiper
                                direction={'horizontal'}
                                slidesPerView={1}
                                spaceBetween={10}
                                // mousewheel={true}
                                pagination={{
                                    dynamicBullets: true,
                                }}

                                breakpoints={{

                                    600: {
                                        slidesPerView: 2,
                                        spaceBetween: 10,
                                    },

                                    900: {
                                        slidesPerView: 3,
                                        spaceBetween: 10,
                                    },

                                    1200: {
                                        slidesPerView: 3,
                                        spaceBetween: 10,
                                    },
                                }}

                                centeredSlides={true}
                                loop={true}
                                autoplay={{
                                    delay: 2500,
                                    disableOnInteraction: false,
                                }}
                                navigation={true}
                                modules={[Mousewheel, Autoplay, Pagination, Navigation]}
                                className="mySwiper"
                            >
                                <SwiperSlide>
                                    <div className="card">
                                        <div className='fex_data'>
                                            <div className="avtar">
                                                <img src={avatar} alt='avatar' />
                                            </div>

                                            <div className="right_detail">
                                                <h5>Ernest Smith</h5>
                                                <h6>Developer at Unixity</h6>

                                                <div className="stars">
                                                    <Star />
                                                    <Star />
                                                    <Star />
                                                    <Star />
                                                    <Star />
                                                </div>
                                            </div>

                                        </div>

                                        <div className="description">
                                            "Outstanding dedication to excellence, exceptional support received. Impressive service!"
                                        </div>
                                    </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <div className="card">
                                        <div className='fex_data'>
                                            <div className="avtar">
                                                <img src={avatar} alt='avatar' />
                                            </div>

                                            <div className="right_detail">
                                                <h5>Stella Smith</h5>
                                                <h6>Engineer at Unify</h6>

                                                <div className="stars">
                                                    <Star />
                                                    <Star />
                                                    <Star />
                                                    <Star />
                                                    <Star />
                                                </div>
                                            </div>

                                        </div>

                                        <div className="description">
                                            "Expertise made all the difference, absolute pleasure to work with. Exceeded our expectations."
                                        </div>
                                    </div>
                                </SwiperSlide>


                                <SwiperSlide>
                                    <div className="card">
                                        <div className='fex_data'>
                                            <div className="avtar">
                                                <img src={avatar} alt='avatar' />
                                            </div>

                                            <div className="right_detail">
                                                <h5>Thomas Smith</h5>
                                                <h6>Designer at Converta</h6>

                                                <div className="stars">
                                                    <Star />
                                                    <Star />
                                                    <Star />
                                                    <Star />
                                                    <Star />
                                                </div>
                                            </div>

                                        </div>

                                        <div className="description">
                                            "Outstanding dedication to excellence, exceptional support received. Impressive service!"
                                        </div>
                                    </div>
                                </SwiperSlide>

                                <SwiperSlide>
                                    <div className="card">
                                        <div className='fex_data'>
                                            <div className="avtar">
                                                <img src={avatar} alt='avatar' />
                                            </div>

                                            <div className="right_detail">
                                                <h5>Ernest Smith</h5>
                                                <h6>Developer at Unixity</h6>

                                                <div className="stars">
                                                    <Star />
                                                    <Star />
                                                    <Star />
                                                    <Star />
                                                    <Star />
                                                </div>
                                            </div>

                                        </div>

                                        <div className="description">
                                            "Outstanding dedication to excellence, exceptional support received. Impressive service!"
                                        </div>
                                    </div>
                                </SwiperSlide>



                                <SwiperSlide>
                                    <div className="card">
                                        <div className='fex_data'>
                                            <div className="avtar">
                                                <img src={avatar} alt='avatar' />
                                            </div>

                                            <div className="right_detail">
                                                <h5>Ernest Smith</h5>
                                                <h6>Developer at Unixity</h6>

                                                <div className="stars">
                                                    <Star />
                                                    <Star />
                                                    <Star />
                                                    <Star />
                                                    <Star />
                                                </div>
                                            </div>

                                        </div>

                                        <div className="description">
                                            "Outstanding dedication to excellence, exceptional support received. Impressive service!"
                                        </div>
                                    </div>
                                </SwiperSlide>


                            </Swiper>
                        </div>
                    </div>
                </div>





            </div >
        </>
    )
}

export default Services